export enum BusEventType {
  COMPLETE_EDIT_BTN_MOUNTED = 'complete-edit-btn:mounted',
  COMPLETE_EDIT_BTN_UNMOUNTED = 'complete-edit-btn:unmounted',
  COMPLETE_EDIT_BTN_CLICKED = 'complete-edit-btn:clicked',
  // Барьер перед уходом со страницы редактора (WSL-5). Слушатель ОБЯЗАН синхронно, внутри
  // обработчика, запустить сохранение: dispatch должен уйти до PROJECT_CLEAN, иначе сага
  // отбросит его по `if (!project) return`. Отложенное на таймер уже не успеет. Дальнейшая
  // работа (запись в IDB, charge в sync-очередь) асинхронна — это нормально: она идёт от
  // уже захваченных данных и переживает очистку проекта.
  EDITOR_FLUSH_PENDING_SAVES = 'editor:flush-pending-saves',
}

export type EventMap = {
  [BusEventType.COMPLETE_EDIT_BTN_MOUNTED]: undefined;
  [BusEventType.COMPLETE_EDIT_BTN_UNMOUNTED]: undefined;
  [BusEventType.COMPLETE_EDIT_BTN_CLICKED]: undefined;
  [BusEventType.EDITOR_FLUSH_PENDING_SAVES]: undefined;
};
